export const VERSION = "1.15.0";


// WEBPACK FOOTER //
// ../lib/env/data.js